<app-layout class="container--md">
    <div>
        <div class="connectionLost__content-container">
            <div class="connectionLost__left">
                <img src="/assets/images/connection-lost-illustration.svg" alt="connection lost">
            </div>
            <div class="connectionLost__right">
                <h1>Connection Timed Out</h1>
                <p>Please refresh your page and try again.</p>
            </div>
        </div>
    </div>
</app-layout>